import React from 'react';
import PropTypes from 'prop-types';

import { NoData, AlertDialog, toast, Loading } from '@meronex/components';

import TeamItem from './TeamItem';
import { teamsMng } from '../api/teamsMng';

function TeamsList(props) {
  const { teams, onEdit, onDelete } = props;

  const [deleting, setDeleting] = React.useState();
  const [openDeleteAlert, setOpenDeleteAlert] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState();

  const _onDelete = (team) => {
    setOpenDeleteAlert(true);
    setSelectedItem(team);
  };

  const onConfirmDelete = async () => {
    setDeleting(true);
    setOpenDeleteAlert(false);
    try {
      await teamsMng.deleteTeam(selectedItem);
      toast.success('Team successfully deleted');
      onDelete();
    } catch (e) {
      toast.error(e.reason);
    } finally {
      setDeleting(false);
    }
  };

  const renderTeams = () => {
    if (!Array.isArray(teams)) {
      return <Loading />;
    } else if (teams.length === 0) {
      return <NoData type={'warn'} />;
    }

    return teams.map((team) => (
      <TeamItem
        key={team._id}
        team={team}
        onEdit={onEdit}
        onDelete={_onDelete}
      />
    ));
  };

  return (
    <>
      <div>{renderTeams()}</div>
      <AlertDialog
        open={openDeleteAlert}
        loading={deleting}
        onClose={() => { setOpenDeleteAlert(false); }}
        onConfirm={onConfirmDelete}
      />
    </>
  );
}
TeamsList.propTypes = {
  teams: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

TeamsList.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};
export default TeamsList;
